<template>
  <div id="aInspectionRouteMap" class="map-container"></div>
</template>

<script>
import { listAdminInspectionRoutePoints } from "@/api/inspection/aInspectionPlanDetailApi";
import {
  addTiandituLabel,
  addTiandituMarker,
  addTiandituPolyline,
  clearTiandituMap,
  fitTiandituViewport,
  loadTiandituMapScript,
} from "@/utils/tiandituMap";

export default {
  name: "AInspectionRouteMap",
  data() {
    return {
      map: null,
      points: [],
    };
  },
  methods: {
    loadData(params) {
      return this.initMap(params);
    },
    async initMap(params) {
      try {
        const { data } = await listAdminInspectionRoutePoints({
          inspectionRouteId: params.inspectionRouteId,
          page: 1,
          row: 1000,
        });
        this.points = data;
        await this.initMapView();
      } catch (error) {
        this.$message.error(this.$t("common.fetchError"));
      }
    },
    async initMapView() {
      if (!this.points || this.points.length === 0) return;
      try {
        await loadTiandituMapScript();
        clearTiandituMap(this.map);
        this.map = new window.T.Map("aInspectionRouteMap", {
          projection: "EPSG:4326",
        });
        const path = [];
        this.points.forEach((point) => {
          const result = addTiandituMarker(this.map, point, {
            title: point.inspectionName,
            iconUrl: "/img/maper.png",
          });
          if (!result) return;
          addTiandituLabel(this.map, result.lngLat, point.inspectionName);
          path.push(result.lngLat);
        });
        addTiandituPolyline(this.map, path);
        fitTiandituViewport(this.map, path, 17);
      } catch (error) {
        console.error("天地图加载失败:", error);
        this.$message.error(this.$t("tiandituMap.loadFailed"));
      }
    },
  },
  beforeDestroy() {
    clearTiandituMap(this.map);
    this.map = null;
  },
};
</script>

<style scoped>
.map-container {
  height: 600px;
  width: 100%;
}
</style>
